module.exports = __webpack_public_path__ + "img/16581302_L.b240631d.png";